import React, { useContext, Fragment } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card'. 'node_modules/@grnhse/seedling/lib/azalea/components/card.js' implicitly has an 'any' type.
} from '@grnhse/seedling/lib/azalea/components/card';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card_table'. 'node_modules/@grnhse/seedling/lib/azalea/components/card_table.js' implicitly has an 'any' type.
import CardTable from '@grnhse/seedling/lib/azalea/components/card_table';
import { SecondaryBodyText } from '@grnhse/seedling/lib/azalea/typography';
import { withLocalePrefix } from 'shared/utils/translation';
import { DataRetentionRulesContext } from './context';
// @ts-expect-error - TS7016 - Could not find a declaration file for module '../shared/error_boundary'. 'app/webpack/javascripts/gdpr/components/shared/error_boundary.js' implicitly has an 'any' type.
import ErrorBoundary from '../shared/error_boundary';
import AddARule from '../shared/add_a_rule';
import { getCardGutter, CardBodyContent } from '../shared/card';
import EmptyState from '../shared/empty_state';
import Loading from '../shared/loading';
import TableHeader from '../shared/table_header';
import EditRule from './edit_rule';
import Rule from './rule';

const t = withLocalePrefix('gdpr.data_retention_rules.view');

function getHeaders() {
  return [
    { key: 'status', label: t('table.header.status'), width: '1%' },
    { key: 'offices', label: t('table.header.offices'), width: '60%' },
    {
      key: 'retention_period',
      label: t('table.header.retention_period'),
      width: '35%',
    },
    { key: 'actions', label: t('table.header.actions'), width: '1%' },
  ];
}

export default function View() {
  const { editing, editingRuleId, rules, loaded, onAdd } = useContext(
    DataRetentionRulesContext
  );

  const header = editing
    ? editingRuleId
      ? t('editing_header')
      : t('creating_header')
    : t('header');

  // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
  const currentRule = rules.find((r) => r.id === editingRuleId);
  const cardGutter = getCardGutter(editing);

  return (
    <Card useLegacyPadding data-provides="gdpr_data_retention_rules">
      <CardHeader
        label={header}
        labelSize="large"
        rightComponent={
          editing ? null : (
            <AddARule onClick={onAdd} dataProvides="add_retention_rule" />
          )
        }
      />
      <CardBody cardGutter={cardGutter} verticalCardGutter="none">
        <CardBodyContent>
          {!loaded ? (
            <Loading />
          ) : !rules.length ? (
            <Fragment>
              <SecondaryBodyText>{t('description')}</SecondaryBodyText>
              {/* @ts-expect-error - TS2769 - No overload matches this call. */}
              <EmptyState emphasize data-provides="no_retention_rules_message">
                {t('table.empty')}
              </EmptyState>
            </Fragment>
          ) : editing ? (
            // @ts-expect-error - TS2322 - Type 'undefined' is not assignable to type 'DataRetentionRuleInterface'.
            <EditRule rule={currentRule} />
          ) : (
            <ErrorBoundary>
              <CardTable
                headerComponent={<TableHeader headers={getHeaders()} />}
              >
                {rules.map((rule) => (
                  // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'never'.
                  <Rule key={rule.id} rule={rule} />
                ))}
              </CardTable>
            </ErrorBoundary>
          )}
        </CardBodyContent>
      </CardBody>
    </Card>
  );
}
